<template lang="html">
  <div class="edit-list-item">
    <Overlay
      width="large"
      :link="overlayLink"
    >

      <div class="create-content">
        <div class="widget-fields-wrapper">
          <ListItemForm
            v-model="listItem"
            :highlightedField="highlightedField"
            :companyId="companyId"
            :siteId="siteId"
            :pageId="pageId"
            :listId="listId"
            :listItemId="listItemId"
            @submit="updateListItem"
            @getData="getData"
            @getListItemData="getListItemData"
            @getPages="getPages"
            :pages="pages"
            :listType="listType"
            :errors="errors"
          />

          <p class="widget-hint">
            Tip: Use a larger screen to use the widget previewer and see changes
            live!
          </p>
        </div>

        <div class="widget-preview-wrapper">
          <WidgetPreviewer
            @highlightField="highlightField"
            :demoMode="false"
            :listType="listType"
            :listItem="listItem"
            :listItems="listItems"
          />
        </div>
      </div>
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'

import {
  readCompanySitePageListListItemsData,
  readCompanySitePageListListItemData,
  updateCompanySitePageListListItemData
} from '@/lib/list_items'

import {readCompanySitePagesData} from '@/lib/pages'

import {readCompanySitePageListData} from '@/lib/lists'
import {readListTypeData} from '@/lib/list_types'

import ListItemForm from '@/components/forms/ListItemForm'
import Overlay from '@/components/Overlay'
import WidgetPreviewer from '@/components/WidgetPreviewer'

export default {
  name: 'EditListItem',

  mixins: [page],

  components: {
    ListItemForm,
    Overlay,
    WidgetPreviewer
  },

  props: {
    companyId: String,
    siteId: String,
    pageId: String,
    listId: String,
    listItemId: String
  },

  data() {
    return {
      list: {},
      listItem: {},
      listItems: [],
      listType: {},
      errors: {},
      pages: [],
      highlightedField: '',
      title: 'Edit List Item'
    }
  },

  computed: {
    overlayLink() {
      if (this.listType.allow_many_items) {
        return {
          name: 'list',
          params: {
            companyId: this.companyId,
            siteId: this.siteId,
            pageId: this.pageId,
            listId: this.listId
          }
        }
      } else {
        return {
          name: 'page',
          params: {
            companyId: this.companyId,
            siteId: this.siteId,
            pageId: this.pageId
          }
        }
      }
    }
  },

  methods: {
    getData() {
      // Read the list so we can get the list_type
      readCompanySitePageListData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId
      ).then(({data}) => {
        this.list = data

        readListTypeData(this.list.list_type_id).then(({data}) => {
          this.listType = data
        })
      })

      this.getListItemData()

      let pagination = {page_size: 250}
      readCompanySitePageListListItemsData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId,
        pagination
      ).then(({data, page}) => {
        this.listItems = data
      })
    },

    getListItemData() {
      readCompanySitePageListListItemData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId,
        this.listItemId
      ).then(({data}) => {
        this.listItem = data
      })
    },

    highlightField(field) {
      this.highlightedField = field
      const el = document.querySelector(`[data-highlight="${field}"]`)
      el.scrollIntoView()
    },

    updateListItem() {
      updateCompanySitePageListListItemData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId,
        this.listItemId,
        this.listItem
      )
        .then(({data}) => {
          this.$emit('updatePage')

          this.$router.push(this.overlayLink)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getPages() {
      readCompanySitePagesData(this.companyId, this.siteId, {
        page: 1,
        page_size: 250
      }).then(({data}) => {
        this.pages = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">
  .edit-list-item
    .input
      transition: all .3s ease-in-out
      border: 1px solid rgba(0, 0, 0, 0)
      padding: 3px
      border-radius: 3px
</style>
